module.exports = __webpack_public_path__ + "static/img/innnnone.b29a4ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dashu/innnnone.png
// module id = HZeK
// module chunks = 1